export class SparkConnectCredentialsAirflowConnectionExtra {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "useSsl",
            "baseName": "use_ssl",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SparkConnectCredentialsAirflowConnectionExtra.attributeTypeMap;
    }
    constructor() {
    }
}
